import { render, staticRenderFns } from "./ApptList.vue?vue&type=template&id=51d34181&"
import script from "./ApptList.vue?vue&type=script&lang=js&"
export * from "./ApptList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports